import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE } from 'constants/constants';
import { QueryTmuDataArgs, TmuData, TmuStaticData } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryTmuDataArgs;

type TData = {
  data: TmuData;
  staticData: TmuStaticData;
};

const MOCK: TVariables = {
  currentLanguagePair: undefined,
  page: FIRST_PAGE,
  query: undefined
};

export const useTMUHasTermsLanguagePairs = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query tmuData($query: String, $page: Int, $currentLanguagePair: String) {
      tmuData(query: $query, page: $page, currentLanguagePair: $currentLanguagePair) {
        data {
          hasTerms
          languagePairs {
            codes
            description
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useTMUHasTermsLanguagePairs', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
